// @ts-strict-ignore
import {Component, Injector, OnDestroy, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Router} from "@angular/router";
import {RegisterResponse, RegisterResult} from "@models";
import {TranslateService} from "@ngx-translate/core";

export type ClientRegisterType = "Player" | "Recorder" | "Tablet" | "ViewingStation" | "MasterOfCeremony";

export interface DialogData_ClientRegisterDialog extends MatDialogDataBaseInput {
	cmd: (initialRequest: boolean) => Promise<RegisterResponse<any>>;
	initial?: RegisterResponse<any>;
	type: ClientRegisterType;
}

export interface DialogData_ClientRegisterDialogOutput extends MatDialogDataBaseOutput {
	result: RegisterResponse<any>;
}

@Component({
	selector: "sim-client-register-dialog",
	templateUrl: "./client-register-dialog.component.html",
	styleUrls: ["./client-register-dialog.component.scss"],
	standalone: false,
})
export class ClientRegisterDialogComponent
	extends BasicMaterialDialog<ClientRegisterDialogComponent, DialogData_ClientRegisterDialog, DialogData_ClientRegisterDialogOutput>
	implements OnInit, OnDestroy
{
	RegisterResult = RegisterResult;

	private isChecking = false;
	private timer: ReturnType<typeof setInterval>;

	public state: RegisterResponse<any>;
	public icon: string;
	public title: string;
	public desc: string;

	constructor(
		_injector: Injector,
		private translate: TranslateService,
		private router: Router,
	) {
		super(_injector);
	}

	ngOnInit(): void {
		this.state = this.data.initial;
		this.setInterval();
		this.setState();
		super.ngOnInit();
	}

	ngOnDestroy(): void {
		this.clearInteral();
	}

	private clearInteral() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	}

	private setInterval() {
		this.timer = setInterval(async () => {
			await this.checkClientRegister();
		}, 5000);
	}

	private async checkClientRegister() {
		if (this.isChecking) {
			return;
		}

		this.isChecking = true;
		this.state = await this.data.cmd(false);
		this.isChecking = false;

		this.setState();
	}

	private setState() {
		if (this.state) {
			switch (this.state.result) {
				case RegisterResult.Success:
					this.icon = "fa-check";
					break;
				case RegisterResult.NotFound:
					this.icon = "fa-search";
					break;
				case RegisterResult.Occupied:
					this.icon = "fa-clone";
					break;
				case RegisterResult.RecordingNotFound:
					this.icon = "fa-search";
					break;
			}

			this.title = this.getLocalization("CLIENT_REGISTER_TITLE_");
			this.desc = this.getLocalization("CLIENT_REGISTER_DESC_");

			if (this.state.result == RegisterResult.Success) {
				this.clearInteral();
				setTimeout(() => {
					this.ok();
				}, 500);
			}
		}
	}

	private getLocalization(key: string): string {
		return this.translate.instant((key + this.data.type + "_" + RegisterResult[this.state.result]).toUpperCase());
	}

	ok() {
		this.close({action: "ok", result: this.state});
	}
}
